'use client'

import Link from 'next/link'
import posthog from 'posthog-js'
import { storeSignupAttribution } from '@/lib/signupAttribution'

// Mirrors PostHogAnalytics: only production reports, and only once posthog has been initialised.
const isProduction = process.env.NEXT_PUBLIC_APP_URL === 'https://culineerapp.com'

const SIGNUP_PATH = '/auth/join-culineer'

/**
 * Sign-up CTA for the landing page test. Two things make it measurable:
 *  - a `landing_cta_click` PostHog event, with which button was clicked
 *  - utm_* params on the link, which PostHog records on the sign-up page's own pageview
 *  - the same values stored locally and sent to the API when the account is created, so the
 *    new user is tagged with the button they signed up from (all environments, not just prod)
 * Not `ref` — that param is the person-to-person referral slug, handled separately.
 */
export default function CtaLink({ id, className, children }: { id: string; className?: string; children: React.ReactNode }) {
  const attribution = { utm_source: 'culineer', utm_medium: 'landing', utm_campaign: 'landing-test', utm_content: id }
  const href = `${SIGNUP_PATH}?${new URLSearchParams(attribution).toString()}`

  const onClick = () => {
    storeSignupAttribution(attribution)
    if (!isProduction || !posthog.__loaded) return
    posthog.capture('landing_cta_click', { cta: id, page: window.location.pathname })
  }

  return (
    <Link href={href} data-cta={id} className={className} onClick={onClick}>
      {children}
    </Link>
  )
}
